<div class="print-export">
  <button type="button" class="bpx-btn print-back-button" (click)="goBack()">
    <mat-icon fontIcon="arrow_back"></mat-icon>
    <span>Go back</span>
  </button>
  <button type="button" class="bpx-btn print-export__trigger" aria-label="Print options"
    [matMenuTriggerFor]="menu" #trigger="matMenuTrigger" (click)="trigger.openMenu(); updateMenuOpenStatus(true);">
    @if (!isPrintDialogOpen) {
      <mat-icon fontIcon="print"></mat-icon>
    }
  </button>

  <mat-menu #menu="matMenu" [hasBackdrop]="menuHasBackdrop" (closed)="updateMenuOpenStatus(false)">
    <ng-template matMenuContent>
    <div (click)="$event.stopPropagation()" class="print-dialog">
      @if (enableColumnSelection) {
      <button mat-raised-button color="primary" type="button" (click)="openColumnSelectionDialog()">
        Select Columns
      </button>
      }

      <div class="print-actions">
        <button mat-raised-button color="primary" type="submit" (click)="openPrinterDialog()">Print</button>
        <button mat-raised-button color="primary" type="button" (click)="trigger.closeMenu()">Cancel</button>
      </div>
    </div>
  </ng-template>
  </mat-menu>
</div>
